import {
  type CustomerAnalyticsMoodysReportDto,
  ZillowMarketReportSectionType,
} from '@zg-rentals/ts-customer-analytics-client';
import { View } from '@react-pdf/renderer';
import { styles } from './pdfStyles';
import {
  MarketTrendsBullet,
  MarketTrendsPageWrapper,
  MarketTrendsParagraph,
  MarketTrendsSubHeading,
  MarketTrendsTextHeader,
} from './MarketTrendsComponents';

export const ZillowResearchPage = ({ report }: { report: CustomerAnalyticsMoodysReportDto }) => {
  const year = report.zillowResearchBySection.NATIONAL_MARKET_OVERVIEW.year;
  const monthNum = report.zillowResearchBySection.NATIONAL_MARKET_OVERVIEW.month;
  const date = new Date(year, monthNum - 1, 1);
  const monthStr = date.toLocaleString('default', { month: 'long' });
  const headerText = `Zillow Research | ${monthStr} ${year} Briefing`;

  return (
    <>
      <MarketTrendsPageWrapper quarter={report.dataAsOfQuarter} year={report.dataAsOfYear}>
        <View style={styles.containerBase}>
          <MarketTrendsTextHeader headerText={headerText} />
          <MarketTrendsSubHeading heading="National Market Overview" />
          {report.zillowResearchBySection.NATIONAL_MARKET_OVERVIEW.content.map((content, i) => (
            <MarketTrendsParagraph key={ZillowMarketReportSectionType.NATIONAL_MARKET_OVERVIEW + i}>
              {content}
            </MarketTrendsParagraph>
          ))}
        </View>
      </MarketTrendsPageWrapper>
      <MarketTrendsPageWrapper quarter={report.dataAsOfQuarter} year={report.dataAsOfYear}>
        <View style={styles.containerBase}>
          <MarketTrendsTextHeader headerText={headerText} />
          <MarketTrendsSubHeading heading="Rents" />
          {report.zillowResearchBySection.RENTS.content.map((content, i) => (
            <MarketTrendsBullet key={ZillowMarketReportSectionType.RENTS + i}>{content}</MarketTrendsBullet>
          ))}
          <MarketTrendsSubHeading heading="Single-Family Rents" />
          {report.zillowResearchBySection.SINGLE_FAMILY_RENTS.content.map((content, i) => (
            <MarketTrendsBullet key={ZillowMarketReportSectionType.SINGLE_FAMILY_RENTS + i}>
              {content}
            </MarketTrendsBullet>
          ))}
          <MarketTrendsSubHeading heading="Multifamily Rents" />
          {report.zillowResearchBySection.MULTIFAMILY_RENTS.content.map((content, i) => (
            <MarketTrendsBullet key={ZillowMarketReportSectionType.MULTIFAMILY_RENTS + i}>{content}</MarketTrendsBullet>
          ))}
          <MarketTrendsSubHeading heading="Rent Concessions" />
          {report.zillowResearchBySection.RENT_CONCESSIONS.content.map((content, i) => (
            <MarketTrendsBullet key={ZillowMarketReportSectionType.RENT_CONCESSIONS + i}>{content}</MarketTrendsBullet>
          ))}
        </View>
      </MarketTrendsPageWrapper>
      <MarketTrendsPageWrapper quarter={report.dataAsOfQuarter} year={report.dataAsOfYear}>
        <View style={styles.containerBase}>
          <MarketTrendsTextHeader headerText={headerText} />
          <MarketTrendsSubHeading heading="Rent Affordability" />
          {report.zillowResearchBySection.RENT_AFFORDABILITY.content.map((content, i) => (
            <MarketTrendsBullet key={ZillowMarketReportSectionType.RENT_AFFORDABILITY + i}>
              {content}
            </MarketTrendsBullet>
          ))}
          {report.zillowResearchBySection.RENTAL_VACANCY_RATE && (
            <>
              <MarketTrendsSubHeading heading="Rental Vacancy Data (Quarterly Data)" />
              {report.zillowResearchBySection.RENTAL_VACANCY_RATE.content.map((content, i) => (
                <MarketTrendsBullet key={ZillowMarketReportSectionType.RENTAL_VACANCY_RATE + i}>
                  {content}
                </MarketTrendsBullet>
              ))}
            </>
          )}
        </View>
      </MarketTrendsPageWrapper>
    </>
  );
};
